const menus = [
    {
        id: 1,
        name: 'Beranda',
        links: '/'
    },
    {
        id: 2,
        name: 'Fitur',
        links: '/features'
    },
    {
        id: 3,
        name: 'Akademi',
        links: '/academy'
    },
    {
        id: 4,
        name: 'Harga',
        links: '/pricing'
    },
    {
        id: 5,
        name: 'Mentor',
        links: '/mentor'
    },
    {
        id: 6,
        name: 'Event',
        links: '/event'
    },
    {
        id: 7,
        name: 'FAQ',
        links: '/faq'
    },
    {
        id: 8,
        name: 'Kontak',
        links: '/contact'
    },
]

export default menus;
